import React from "react";

function Footer() {
    return (
        <footer>
            <p>Made by Juan Acaiturri Copyright © 2019 powered by Yandex Translate. </p>
        </footer>
    )
}

export default Footer